import { render, staticRenderFns } from "./OfficePropertiesForRent.vue?vue&type=template&id=262a9e96&"
import script from "./OfficePropertiesForRent.vue?vue&type=script&lang=ts&"
export * from "./OfficePropertiesForRent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports